import { ChevronLeftIcon } from '@chakra-ui/icons';
import { Box, Card, Flex, Heading, IconButton } from '@chakra-ui/react';
import React, { useCallback } from 'react';
import { spacing, typography, useSemanticColor } from 'theme/tokens';

type Props = { title: string; rightHeader?: React.ReactNode; children?: React.ReactNode; showBackButton?: boolean }
export default function PageCard({ title, rightHeader, children, showBackButton }: Props) {
    const textColor = useSemanticColor('textPrimary');
    const onBack = useCallback(() => {
        window.history.back();
    }, []);

    return (
        <Card borderRadius='16px' flexDirection='column' pt={spacing.card} w='100%' px='0px' overflowY='hidden' overflowX={{ sm: 'scroll', lg: 'hidden' }}>
            <Flex px={spacing.cardHeader} mb={2} justifyContent='space-between' align='center'>
                <Flex align="center">
                    {showBackButton && <IconButton
                        aria-label="Back"
                        icon={<ChevronLeftIcon />}
                        variant="ghost"
                        onClick={onBack}
                    />}
                    <Heading as="h2" color={textColor} {...typography.pageTitle}>
                        {title}
                    </Heading>
                </Flex>
                {rightHeader}
            </Flex>
            <Box minWidth={0}>{children}</Box>
        </Card>
    )
}
